import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from '../ui/Button';
import Input from '../ui/Input';
import AuthLayout, { PasswordField } from '../shell/AuthLayout';

// HD-4: Portal profile on src/ui (DESIGN rev 2.1 §3.3). Same sign-in logic as before.
export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Sign-in failed. Check your email and password, then try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h1 className="ui-auth__title">Sign in</h1>
      <form className="ui-auth__form" onSubmit={handleSubmit}>
        <Input label="Email" type="email" placeholder="you@journeyviral.com" value={email} onChange={e => setEmail(e.target.value)} required autoFocus autoComplete="email" />
        <PasswordField label="Password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
        {error && <p className="ui-auth__alert" role="alert">{error}</p>}
        <Button type="submit" variant="primary" portal loading={loading}>Sign in</Button>
      </form>
      <Link className="ui-auth__link" to="/forgot-password">Forgot your password?</Link>
    </AuthLayout>
  );
}
